/**
* description:
* File of sErrorHandler Serivce
*
* Serwis jest odpowiedzialny za obsługę błędów otrzymanych z API.
*
* data : 2017-08-15
*/

import errorMessages from '@/services/utils/errorMessages';

const sErrorHandler = (() => {
  return {
    createErrorMessage,
  };
  // /// PRIVATE ////////////////////////////////////////////////////////////////
  function __getFirstErrorType(errors) {
    const type = Object.keys(errors)[0];
    const error = errors[type][0];

    return `${type}|${error}`;
  }

  // /// PUBLIC /////////////////////////////////////////////////////////////////
  function createErrorMessage(errors) {
    return errorMessages[__getFirstErrorType(errors)] || 'Wystąpił nieoczekiwany błąd';
  }
})();

export default sErrorHandler;



// WEBPACK FOOTER //
// ./src/services/sErrorHandler.js